export const sliderItems = [
    {
        id: 1,
        img: "https://images.pexels.com/photos/4846087/pexels-photo-4846087.jpeg?cs=srgb&dl=pexels-rachel-claire-4846087.jpg&fm=jpg",
        title: "Top cleaning company",
        description: "Salas Sofás Sillas colchones Asientos de carro Y mas...",
        button: "Call now",
        bg: "background-color: #E4E4E1; background-image: radial-gradient(at top center, rgba(255,255,255,0.03) 0%, rgba(0,0,0,0.03) 100%), linear-gradient(to top, rgba(255,255,255,0.1) 0%, rgba(143,152,157,0.60) 100%); background-blend-mode: normal, multiply;",
    },
    {
        id: 2,
        img: "https://images.pexels.com/photos/2079249/pexels-photo-2079249.jpeg?cs=srgb&dl=pexels-emre-can-acer-2079249.jpg&fm=jpg",
        title: "A good living room design",
        description: "Decorating your living room? We've compiled gorgeous living room ideas to use as a starting point for your next decorating project",
        button: "Read more",
        bg: "background-image: linear-gradient(to top, #c79081 0%, #dfa579 100%);",
    },
    {
        id: 3,
        img: "https://images.pexels.com/photos/3965520/pexels-photo-3965520.jpeg?cs=srgb&dl=pexels-ksenia-chernaya-3965520.jpg&fm=jpg",
        title: "How do we take care of your furniture?",
        description: "Our cleaning methods offer the deepest level of clean possible for the floors throughout your home, but we’re also committed to using a process that is safer for your home and your family.",
        button: "See how",
        bg: "background-image: linear-gradient(to top, #a7a6cb 0%, #8989ba 52%, #8989ba 100%);",
    },
    {
        id: 4,
        img: "https://images.pexels.com/photos/5824901/pexels-photo-5824901.jpeg?cs=srgb&dl=pexels-charlotte-may-5824901.jpg&fm=jpg",
        title: "Furniture health matters",
        description: "Follow these care tips to help prevent moisture or dryness from damaging your furniture",
        button: "See tips",
        bg: "background-image: linear-gradient(to right, #868f96 0%, #596164 100%);",
    },
];

export const categories = [
    {
        id: 1,
        img: "https://marvel-b1-cdn.bc0a.com/f00000000172387/stanleysteemer-cdn-profile-1.azureedge.net/prod-container/images/default-source/global-images/20181120_image-website-upholstery.png?sfvrsn=1441aa81_2",
        title: "Upholstery cleaning",
    },
    {
        id: 2,
        img: "https://images.pexels.com/photos/164446/pexels-photo-164446.jpeg?cs=srgb&dl=pexels-pixabay-164446.jpg&fm=jpg",
        title: "Carpet cleaning",
    },
    {
        id: 3,
        img: "https://images.pexels.com/photos/4239037/pexels-photo-4239037.jpeg?cs=srgb&dl=pexels-karolina-grabowska-4239037.jpg&fm=jpg",
        title: "House cleaning",
    },
    {
        id: 4,
        img: "https://images.pexels.com/photos/4792478/pexels-photo-4792478.jpeg?cs=srgb&dl=pexels-anete-lusina-4792478.jpg&fm=jpg",
        title: "Maintenace in general",
    },
];

export const services = [
    {
        id: 1,
        img: "https://images.pexels.com/photos/8082560/pexels-photo-8082560.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-8082560.jpg&fm=jpg",
        title: "Chair",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 2,
        img: "https://images.pexels.com/photos/3757055/pexels-photo-3757055.jpeg?cs=srgb&dl=pexels-andrea-piacquadio-3757055.jpg&fm=jpg",
        title: "Loveseat",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 3,
        img: "https://images.pexels.com/photos/4846097/pexels-photo-4846097.jpeg?cs=srgb&dl=pexels-rachel-claire-4846097.jpg&fm=jpg",
        title: "Sofa",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 4,
        img: "https://images.pexels.com/photos/6588592/pexels-photo-6588592.jpeg?cs=srgb&dl=pexels-max-vakhtbovych-6588592.jpg&fm=jpg",
        title: "Sectional",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 5,
        img: "https://imageresizer.furnituredealer.net/img/remote/images.furnituredealer.net/img/products%2ffusion_furniture%2fcolor%2f4480-kp_4483basic%20wool-b1.jpg?width=878&height=600&scale=both&trim.threshold=80",
        title: "Ottoman",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 6,
        img: "https://images.pexels.com/photos/534172/pexels-photo-534172.jpeg?cs=srgb&dl=pexels-pixabay-534172.jpg&fm=jpg",
        title: "Dining chair",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 7,
        img: "https://housewifehowtos.com/wp-content/uploads/2021/04/How-to-Clean-a-Mattress-Get-Rid-of-Stains-and-Smells-1024x683.jpeg.webp",
        title: "Mattress",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 8,
        img: "https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/Articles/how-to-clean-carpet-step-4.jpg",
        title: "Carpet cleaning",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 9,
        img: "https://images.pexels.com/photos/4239031/pexels-photo-4239031.jpeg?cs=srgb&dl=pexels-karolina-grabowska-4239031.jpg&fm=jpg",
        title: "House cleaning",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
    {
        id: 10,
        img: "https://images.pexels.com/photos/5768284/pexels-photo-5768284.jpeg?cs=srgb&dl=pexels-ksenia-chernaya-5768284.jpg&fm=jpg",
        title: "Maintenace in general",
        description: "We price upholstery differently depending on the furniture piece and size."
    },
];
